// labels

export const marketLabels = {
    ID: 'INDONESIA',
    PH: 'PHILIPPINES',
    AR: 'ARGENTINA',
};
export const categoryLabels = {
    CC: 'CONVENTIONAL CIGARETTES',
    SFP: 'SMOKE FREE PRODUCTS'
};
export const brandLabels = {
    MARLBORO: 'MARLBORO',
    MAGNUM: 'MAGNUM',
    FORTUNE: 'FORTUNE',
};
